export const teamMembers = [
  {
    name: 'Niel Kasselman',
    role: 'Business Owner & Industry Specialist',
    initials: 'NK',
    photo: '/team/niel.jpeg',
    description:
      'With more than 30 years in the building industry, Niel leads OJANNA Ceiling & Drywall Distributors with hands-on expertise and a passion for quality. As an accredited Green Building Council Professional, he advises clients on energy-efficient building solutions.',
    highlight: true,
  },
  {
    name: 'Lucrechia Muller',
    role: 'Sales Consultant & Stock Controller',
    initials: 'LM',
    photo: '/team/lucrisha.jpeg',
    description:
      'Lucrechia manages sales consultations and stock control, ensuring customers receive expert product advice and that inventory is accurately maintained.',
  },
  {
    name: 'Nadia van der Merwe',
    role: 'Finance & Administration',
    initials: 'N',
    photo: '/team/nadia.jpeg',
    description:
      'Nadia oversees finance and administration, ensuring smooth operations and that clients receive prompt and professional assistance.',
  },
  {
    name: 'Nothan Muller',
    role: 'Supervisor & Delivery Driver',
    initials: 'NM',
    photo: '/team/northan.jpeg',
    description:
      'Nothan supervises operations and delivery, ensuring that products are prepared and dispatched to the highest standard.',
  },
  {
    name: 'Hinrey Willemse',
    role: 'Forklift Driver & Stores Controller',
    initials: 'HW',
    photo: '/team/hinrey.jpeg',
    description:
      'Hinrey manages forklift operations and stores control, ensuring products are handled with care from our shelves to your site.',
  },
  {
    name: 'Theo Jansen',
    role: 'Stores & Delivery Support',
    initials: 'TJ',
    photo: '/team/theo.jpeg',
    description:
      'Theo provides stores and delivery support, working hard to pick, pack and deliver your building materials safely and on time.',
  },
];
